import $ from 'jquery';
import Lockr from 'lockr';

export default class Sound {
  constructor($c) {
    this.$c = $c;
    this.audio = $c.find('.js-sound-control')[0];
    this.$tracks = $c.find('.js-sound-track');
    this.index = 0;
    this.wantPlay = false;

    const saved = Sound.read();
    this.load(saved.index, false);
    this.restore(saved.time, () => {
      if (saved.play) this.toggle(true);
    });

    this.audio.addEventListener('ended', () => this.step(1));
    this.audio.addEventListener('timeupdate', () => this.remember());
    window.addEventListener('pagehide', () => this.save());

    $c.on('click', '.js-sound-toggle', (e) => {
      e.preventDefault();
      this.toggle(this.audio.paused);
    });
    $c.on('click', '.js-sound-prev', (e) => {
      e.preventDefault();
      this.step(-1);
    });
    $c.on('click', '.js-sound-next', (e) => {
      e.preventDefault();
      this.step(1);
    });
    $c.on('click', '.js-sound-track', (e) => {
      e.preventDefault();
      this.load(Number($(e.currentTarget).data('index')), true);
    });

  }
  load(index, play) {
    const count = this.$tracks.length;
    if (!count || !this.audio) return;

    this.index = (index + count) % count;
    const src = this.$tracks.eq(this.index).attr('data-src');
    if (this.currentSrc !== src) {
      this.currentSrc = src;
      this.audio.src = src;
    }

    this.$tracks.removeClass('_active');
    this.$tracks.eq(this.index).addClass('_active');
    this.$c.find('.js-sound-now').text(String(this.index + 1).padStart(2, '0'));

    if (play || this.wantPlay) this.toggle(true);
  }
  step(dir) {
    this.load(this.index + dir, this.wantPlay);
  }
  async toggle(play) {
    this.wantPlay = play;
    if (play) {
      try {
        await this.audio.play();
      } catch (e) {
        this.wantPlay = false;
        Sound.status = false;
        this.$c.removeClass('_played');
        this.save();
        return;
      }
    } else {
      this.audio.pause();
    }

    Sound.status = play;
    this.$c.toggleClass('_played', play);
    this.save();
  }
  restore(time, done) {
    const finish = () => {
      if (time > 0.3 && Number.isFinite(this.audio.duration)) {
        this.audio.currentTime = Math.min(time, Math.max(this.audio.duration - 0.3, 0));
      }
      this.restored = true;
      done();
    };

    if (!(time > 0.3)) {
      this.restored = true;
      done();
      return;
    }

    this.audio.preload = 'metadata';
    if (this.audio.readyState >= 1) finish();
    else {
      this.audio.addEventListener('loadedmetadata', finish, { once: true });
      this.audio.load();
    }
  }
  remember() {
    if (!this.restored) return;
    const now = Date.now();
    if (now - (this.savedAt || 0) < 1000) return;
    this.savedAt = now;
    this.save();
  }
  save() {
    Lockr.set('sound-player', {
      play: !!this.wantPlay,
      index: this.index || 0,
      time: this.audio && this.audio.currentTime ? this.audio.currentTime : 0
    });
  }
  static read() {
    const saved = Lockr.get('sound-player');
    if (saved && typeof saved === 'object') {
      return {
        play: !!saved.play,
        index: Number(saved.index) || 0,
        time: Number(saved.time) || 0
      };
    }
    if (Sound.status === undefined) return { play: true, index: 0, time: 0 };
    return { play: !!Sound.status, index: 0, time: 0 };
  }
  static get status() {
    return Lockr.get('sound');
  }
  static set status(value) {
    Lockr.set('sound', value);
  }
}
